import BaseModel from '../../../../base/base_model';
import {KEY_NAME} from '../../native/native_const';
import {TOUCH_ID} from './touch_id_consts';
import Store from '../../../../utils/store';
import _ from '../../../../utils/underscore';
import Device from '../../../../utils/device/device';
import ServiceFactory from '../../../service_factory';



class TouchIDModel extends BaseModel {

    static CLASS = 'TouchIDModel';

    _bTestPC = false;

    _isFeatureEnable = false;

    _token = '';
    _srvtoken = '';
    _deviceId = '';
    _bundleId = '';
    _deviceTouchEnable = false;
    _success = '';
    _reason = '';
    _loginWithTouch = false;
    _autoLogin = false;

    /*
     * init the params to be an json object.
     * @params is string from web.config
     * @params is json object from html
     */
    init(params) {

        this._bTestPC = Device.hybrid.isHybrid ? false : this._bTestPC;

        this._isFeatureEnable = true === params.enable && Device.hybrid.isHybrid;

        if (true === this._bTestPC) {
            this._isFeatureEnable = 'true' === params.enable; // to debug on PC
        }

        this._initSuccess();
        super.init(params);
    }

    /**
     * set Auto Login val
     * bVal true/false
     */
    setAutoLogin(bVal) {
        this._autoLogin = bVal;
    }

    /**
     * is Auto Login
     * return bool
     */
    isAutoLogin() {
        return this._autoLogin;
    }

    /**
     * is Auto Login with touch id - the login was made with the touch id token
     * return bool
     */
    isloginWithTouch() {
        return this._loginWithTouch;
    }

    /**
     * set logi nWith Touch id - if true then the login is made with the touchid token
     * bVal true/false
     */
    setloginWithTouch(bVal) {
        this._loginWithTouch = bVal;
    }

    /**
     * return true if the user already click on the screen buttons(he saw the screen already)
     * return bool
     */
    _getIsInitScreenShowed() {

        let val = Store.get(TOUCH_ID.KEY_TOUCH_ACTIVATION_CLICKED, 'false');
        return val === 'false' ? true : false;
    }

    /*
     * set Init screen is showed
     * @params bool
     * need to update only when screen is displayed.
     */
    setInitScreenShowed(val) {
        Store.set(TOUCH_ID.KEY_TOUCH_ACTIVATION_CLICKED, val);
    }


    /**
     * return true if the touchid is enabled
     * return bool
     */
    isFeatureEnable() {
        return this._isFeatureEnable;
    }

    /**
     * return the token that was saved in the hybrid
     * return string
     */
    getToken() {
        return this._token;
    }

    /**
     * return the token that was send from the server
     * return string
     */
    getSrvToken() {
        return this._srvtoken;
    }

    /**
     * return true if the token is not empty
     * return bool
     */
    isSrvTokenValid() {
        return this._srvtoken.length > 0;
    }

    /**
     * set Server Token - save the token that arrived from server
     * example params: Token_PFRva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uIEF1dGhlbnRpY2F0aW9uQmxvY2s9IjRhOWM1ZmNlLWM2ZGEtNGM2ZS1iYmNmLTU5MDc5MGEzMWRmMSIgRW5jcnlwdGlvblR5cGU9IjgiPg0KICA8VGFyZ2V0VHlwZVZhbHVlPnsiQnVuZGxlSWQiOiJjb20uaHlicmlkY2dwLnJsIiwiRGV2aWNlSWQiOiIxMzY5NDNEQS02QzYxLTRFOTctODcxQS0zODA5QTExNkZFQ0MifTwvVGFyZ2V0VHlwZVZhbHVlPg0KICA8VG9rZW5Tb3VyY2U+VG91Y2hJZDwvVG9rZW5Tb3VyY2U+DQo8L1Rva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uPg==%22%7D%7D
     */
    setSrvToken(params) {
        this._srvtoken = params.token;
    }

    /**
     * return true if the token is empty
     * return bool
     */
    isTokenEmpty() {
        return _.isEmpty(this._token);
    }

    /**
     * return true if the touch id is enable
     * return bool
     */
    isDeviceTouchEnable() {
        return this._deviceTouchEnable;
    }

    /**
     * return true if the touch id is enable and we have a token
     * return bool
     */
    isTokenEnable() {
        return this._token.length > 0 && true === this._deviceTouchEnable;
    }

    /**
     * can Display Autoomatic Activation Screen
     * the screen didn't display ever.
     * the token is empty.
     * the IOS support the touch Feature.
     * @returns BOOL
     */
    canDisplayInitializeScreen() {
        if (true === this._bTestPC) {
            return true;
        }

        return this._getIsInitScreenShowed() && this.isTokenEmpty() && this.isDeviceTouchEnable();
    }

    getText(id) {

        let txt = ServiceFactory.create().languageService().translation(id);

        if (undefined === txt) {
            txt = '';
        }

        return txt;
    }

    _initSuccess() {
        this._success = false;
        this._reason = 1000;
    }

    /**
    * setEnableRes - enable the touch id
    * json: {error: 0, data: {touchenable: "true"}}
    */
    setEnableRes(json) {
        let error = json[KEY_NAME.ERROR];
        if (error !== 0) {
            return;
        }
        let tokenData = json[KEY_NAME.DATA];

        this._updateTouchEnable(tokenData);
    }

    /**
     * setResTouchParams - set the resault from the touch id
     * json: {error: 0, data: {success: "true", reason: "0"}}
     */
    setResTouchParams(json) {
        let error = json[KEY_NAME.ERROR];
        if (error !== 0) {
            this._initSuccess();
            return;
        }
        let data = json[KEY_NAME.DATA];

        this._success = data[TOUCH_ID.KEY_SUCCESS] === 'true';
        this._reason = Number(data[TOUCH_ID.KEY_REASON]);
    }

    isSuccess() {
        return this._success;
    }

    getReason() {
        return this._reason;
    }

    isEnableWithoutToken() {
        return this._deviceTouchEnable && this._token.length === 0;
    }

    /**
     * set TokenData from hybrid
     * data example:  "%7B%22error%22:0,%22data%22:%7B%22touchenable%22:%22true%22,%22touch_token%22:%22Token_PFRva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uIEF1dGhlbnRpY2F0aW9uQm
     * xvY2s9ImNlYTVlMzBhLTMzOWUtNGFiNy05MjFlLTNiNzIwMjE3OGNiOCIgRW5jcnlwdGlvblR5cGU9IjgiPg0KICA8VGFyZ2V0VHlwZVZhbHVlPnsiQnVuZGxlSWQiOiJjb20uaHlicmlkY2dwLnJsIiwi
     * RGV2aWNlSWQiOiJBRjBDNjU1MC05QjU5LTQxNDktOEE5RS02MzhFQTRDNzUyN0QifTwvVGFyZ2V0VHlwZVZhbHVlPg0KICA8VG9rZW5Tb3VyY2U+VG91Y2hJZDwvVG9rZW5Tb3VyY2U+DQo8L1Rva2VuQm
     * xvYkZvckF1dGhlbnRpY2F0aW9uPg==%22%7D%7D
     */
    setTokenData(data) {

        data = _.safeJSONandDecode(data);

        let error = data[KEY_NAME.ERROR];
        if (error !== 0) {
            return;
        }

        let tokenData = data[KEY_NAME.DATA];

        this._updateTokenData(tokenData);
    }


    /**
    * set TokenData from hybrid
    * tokenData example:  {touchenable: "true", touch_token: "Token_PFRva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uIEF1dGh......yY2U+DQo8L1Rva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uPg=="}
    */
    _updateTokenData(tokenData) {
        this._token = tokenData[TOUCH_ID.KEY_TOKEN];
        this._updateTouchEnable(tokenData);
    }

    _updateTouchEnable(tokenData) {
        this._deviceTouchEnable = tokenData[TOUCH_ID.KEY_TOUCH_ENABLE] === 'true' && this._isFeatureEnable;
    }

    saveParamsForToken(data) {
        data = _.safeJSONandDecode(data);

        let error = data[KEY_NAME.ERROR];
        if (error !== 0) {
            return;
        }

        let tokenData = data[KEY_NAME.DATA];
        this.saveTokenData(tokenData);
    }

    /**
    * save Token Data from hybrid
    * tokenData example:  {DeviceId: "2DE2325B-412C-4218-8FA7-A7B1A98C28E3", BundleId: "com.hybridcgp.rl"}
     */
    saveTokenData(tokenData) {
        this._deviceId = tokenData[TOUCH_ID.KEY_DEVICE_ID];
        this._bundleId = tokenData[TOUCH_ID.KEY_BUNDLE_ID];
    }

    /**
     * get Params For Token
     * return  Params example:  TargetTypeValue: "{\"BundleId\":\"com.hybridcgp.rl\",\"DeviceId\":\"D0D8E990-4ED5-4F8A-ADBA-6507DA328C52\"}", TargetType: 2}
     */
    getParamsForToken() {
        let targetvalueParams = {
            [TOUCH_ID.KEY_BUNDLE_ID]: this._bundleId,
            [TOUCH_ID.KEY_DEVICE_ID]: this._deviceId
        };

        let params = {
            [TOUCH_ID.KEY_TARGET_TYPE_VALUE]: JSON.stringify(targetvalueParams),
            [TOUCH_ID.KEY_TARGET_TYPE]: 2
        };
        return params;
    }
    /**
     * get Params for login
     * return  Params example:  {BundleId: "com.hybridcgp.rl", DeviceId: "D0D8E990-4ED5-4F8A-ADBA-6507DA328C52", touch_token: "Token_PFRva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uIEF1dGhl…yY2U+DQo8L1Rva2VuQmxvYkZvckF1dGhlbnRpY2F0aW9uPg=="}
     */
    getParamsForLogin() {
        let params = {
            [TOUCH_ID.KEY_BUNDLE_ID]: this._bundleId,
            [TOUCH_ID.KEY_DEVICE_ID]: this._deviceId,
            [TOUCH_ID.KEY_TOKEN]: this._token
        };
        return params;
    }
}

export default TouchIDModel;
